<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title-1">A Letter from Nero Blanc</p>
<p class="normal">Dear Friends,</p>
<p class="indent">Connecting writers to readers requires a special talent, and we’d like to acknowledge the many people whose savvy, humor, and insight—not to mention business acumen—have made our mysteries a success story. Each of you deserves an Author’s Appreciation Award. Lacking a suitable lexical offering, we’ll simply list you and extend a multitude of kudos from two very grateful authors.</p>
<p class="indent">Thank you to: Mary Alice and Richard of Mystery Lovers Bookshop; Jim at The Mystery Company; Sharon at Books &amp; Company; Barbara and The Poisoned Pen; Creatures ’n Crooks and Lelia; Bonnie and Joe of The Black Orchid Bookshop; Augie of Centuries &amp; Sleuths; Bruce and Turn the Page; Mystery Loves Company’s Kathy; The Mystery Bookstore’s Sheldon; Ed and Jean at M is for Mystery; Partners &amp; Crime and Marshall; Richard at Head House Books; Joanne at Murder on the Beach; Booked for Murder’s Mary Helen; Tom of Murder Ink; Bridge Street Books’ Suzanne; Debbie at Mechanicsburg Mystery Bookshop; Angie of Voices and Visions; The Book Garden and Esther; Barry of Book’em Mysteries; Katie of Village Books; Kate at Kate’s Mystery Books; the many kind folks at Chester County Books, The Bookworm, and Baker Books; and, last but not least, Nancy of The Virginia Festival of the Book.</p>
<p class="right"><span>Getting to know you has been a delight,</span></p>
<p class="righta"><span>Cordelia and Steve</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter01.vue?242c94cf